import {OverlayContainer} from "@angular/cdk/overlay"
import {initializeConsoleApi, LOGGING_PROVIDERS} from "@common/services/logging"
import {provideHttpClient} from "@angular/common/http"
import {enableProdMode, ErrorHandler, Injectable, provideZonelessChangeDetection} from "@angular/core"
import {getAnalytics, provideAnalytics} from "@angular/fire/analytics"
import {initializeApp, provideFirebaseApp} from "@angular/fire/app"
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter} from "@angular/material/core"
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from "@angular/material/form-field"
import {bootstrapApplication, HAMMER_GESTURE_CONFIG} from "@angular/platform-browser"
import {provideAnimations} from "@angular/platform-browser/animations"
import {provideRouter, withComponentInputBinding, withRouterConfig} from "@angular/router"
import {AppComponent} from "@app/app.component"
import {cmApolloConfig} from "@common/config/apollo"
import {CM_COLORMASS_CLIENT} from "@common/config/client-injector"
import {HammerConfig} from "@common/config/hammer"
import {cmTippyConfig} from "@common/config/tippy"
import {CM_DATE_FORMATS} from "@common/models/settings/settings"
import {ErrorHandlerService} from "@common/services/error-handler-service/error-handler-service.service"
import {environment} from "@environment"
import {provideTippyConfig, provideTippyLoader} from "@ngneat/helipopper/config"
import tippy from "tippy.js"
import {routes} from "@platform/config/routes"
import {provideApollo} from "apollo-angular"
import {loggerFactory} from "@cm/browser-log"
// Side-effect import: registers the mattress template-graph node classes (split out of @cm/template-nodes into @cm/mattress-nodes)
import "@cm/mattress-nodes"

if (environment.production) {
    enableProdMode()
}

// Initialize browser console API for runtime log configuration (cmLog.setLevel(), etc.)
initializeConsoleApi()

const appLogger = loggerFactory.getLogger("app")

@Injectable({providedIn: "root"})
export class CdkOverlayContainer extends OverlayContainer {}

void bootstrapApplication(AppComponent, {
    providers: [
        {
            provide: ErrorHandler,
            useClass: ErrorHandlerService,
        },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: HammerConfig,
        },
        {provide: MAT_DATE_FORMATS, useValue: CM_DATE_FORMATS},
        {provide: MAT_DATE_LOCALE, useValue: "en-GB"},
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: "outline",
                floatLabel: "always",
                subscriptSizing: "dynamic",
            },
        },
        {provide: CM_COLORMASS_CLIENT, useValue: "platform"},
        provideAnalytics(() => getAnalytics()),
        provideAnimations(),
        provideApollo(cmApolloConfig),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideHttpClient(),
        provideNativeDateAdapter(),
        provideRouter(routes, withRouterConfig({paramsInheritanceStrategy: "always"}), withComponentInputBinding()),
        provideTippyLoader(() => tippy),
        provideTippyConfig(cmTippyConfig),
        provideZonelessChangeDetection(),
        ...LOGGING_PROVIDERS,
    ],
}).catch((err) => appLogger.error(err))
